import { CourseOutlineTask } from './course-outline-task'

export interface OutlineInterface {
  parentId?: number
  /**
   * 活动任务
   */
  activityTaskId?: number
  /**
   * 目录任务
   */
  outlineTaskIds?: number[]
  name?: string
  weight?: number
  /**
   * 目录关联任务
   * expand=outline.tasks会返回该值
   */
  tasks?: CourseOutlineTask[]
  /**
   * 目录关联任务完成情况
   *  - {"outline_task_id":"completed_sum"}
   */
  taskCompletedInfo?: object
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Outline implements OutlineInterface {
  parentId?: number
  /**
   * 活动任务
   */
  activityTaskId?: number
  /**
   * 目录任务
   */
  outlineTaskIds?: number[]
  name?: string
  weight?: number
  /**
   * 目录关联任务
   * expand=outline.tasks会返回该值
   */
  tasks?: CourseOutlineTask[]
  /**
   * 目录关联任务完成情况
   *  - {"outline_task_id":"completed_sum"}
   */
  taskCompletedInfo?: object
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: OutlineInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      parentId: _parentId,
      activityTaskId: _activityTaskId,
      outlineTaskIds: _outlineTaskIds,
      name: _name,
      weight: _weight,
      tasks: _tasks,
      taskCompletedInfo: _taskCompletedInfo,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.parentId = _parentId
    this.activityTaskId = _activityTaskId
    this.outlineTaskIds = _outlineTaskIds
    this.name = _name
    this.weight = _weight
    this.tasks = _tasks ? _tasks.map((i) => new CourseOutlineTask(i)) : _tasks
    this.taskCompletedInfo = _taskCompletedInfo
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
